import type { Dispatch } from 'redux';

import { getSignInForOrg } from 'af-utils/localStorage.util';
import { getCurrentOrgAlias } from 'af-utils/window.util';

import * as generalActionCreators from 'af-actions/general/general.actionCreators';

export const getCurrentUserEmailFromLocalStorage = () => {
	const _currentOrgAlias = getCurrentOrgAlias();
	return _currentOrgAlias
		? getSignInForOrg(_currentOrgAlias)?.email ?? null
		: null;
};

export function showRefreshModal() {
	return (dispatch: Dispatch<generalActionCreators.GeneralAction>) => {
		dispatch(generalActionCreators.SHOW_REFRESH_MODAL());
	};
}

export function hideRefreshModal() {
	return (dispatch: Dispatch<generalActionCreators.GeneralAction>) => {
		dispatch(generalActionCreators.HIDE_REFRESH_MODAL());
	};
}
